import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { WardsService } from '../../../../../services/wards-service/wards.service';
import { Student } from '../../../../../models/student';
import { combineLatest, Subscription } from 'rxjs';
import { PersonType } from '../../../../../models/person';
import { pages } from '../../../../../utils/pages';
import { Message } from '../../models/message';
import { MessagesService } from '../../services/message-service/messages.service';
import { UserService } from 'src/app/services/user/user-service/user.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessagesComponent extends ComponentBase implements OnInit {

  messages: Array<Message>;
  selectedMessage: Message;
  loading: boolean = true;
  option = 1;
  replyMode = false;
  wards: Array<Student>;
  personType: PersonType;

  public config: PerfectScrollbarConfigInterface = {};

  public folder: string = "inbox";
  public filterId: string;

  constructor(private pageHeadingService: PageHeadingService
    , private renderer: Renderer2
    , private messagesService: MessagesService
    , private route: ActivatedRoute
    , private wardsService: WardsService
    , private userService: UserService
    , private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Messages"));

    let sub = this.userService.getLoggedInUser().subscribe(user => {
      this.personType = user.person.person_type;
    });
    this.addSubscription(sub);

    let wardSubscription = this.wardsService.wards$
      .subscribe((wards) => {
        this.wards = wards;
      });
    this.addSubscription(wardSubscription);

    let subscription = this.route.queryParams
      .pipe(
        distinctUntilChanged(),
        switchMap((qp) => {
          this.selectedMessage = null;
          this.folder = qp['folder'];
          this.filterId = qp['filterId'];
          if (!this.folder) {
            this.folder = "inbox";
          }
          if (!this.filterId) {
            this.filterId = "";
          }

          return this.messagesService.getMessages(this.filterId ? +this.filterId : null, this.folder);
        }),
        switchMap((messages: Message[]) => {
          return this.route.params.pipe(
            map((params) => {
              return { messages, params };
            })
          );
        })
      )
      .subscribe(({ messages, params }) => {
        let id = +params['id'];
        this.loading = false;
        this.messages = messages;

        if (!id && this.messages.length) {
          this.selectedMessage = this.messages[0]
        }
        else if (id) {
          this.selectedMessage = this.messages.find(o => o.message_id == id);
        }
        if (this.selectedMessage) {
          this.messageClicked = true;
        }
      });
    this.addSubscription(subscription);
  }
  public messageClicked = false;
  messageItemClicked(message: Message) {
    this.renderer.addClass(document.body, 'second-page');
    this.messageClicked = true;
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'messages', message.message_id];
    route.append_current_url_to_history = true;
    route.query_params = {};
    route.query_params['folder'] = this.folder;
    route.query_params['filterId'] = this.filterId;
    route.replace_url = true;
    route.page_name = pages.messageDetails;
    this.routingService.navigate(route);
  }

  radioMenuClicked(option) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'messages'];
    route.query_params = {};
    route.query_params['filterId'] = this.filterId;
    route.query_params['folder'] = option;
    route.append_current_url_to_history = false;
    route.page_name = pages.message;
    this.routingService.navigate(route);
  }

  filterSelected(option) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'messages'];
    route.query_params = {};
    route.query_params['filterId'] = option;
    route.append_current_url_to_history = false;
    route.page_name = pages.message;
    this.routingService.navigate(route);
  }
}
